<cs-header>
  <cs-header-title>{{ LL.schedule.tips() }}</cs-header-title>
</cs-header>

<cs-content>
  <ol class="tip-list">
    @for (tip of tips; track tip; let tipIndex = $index) {
      <li>
        <div class="tip">
          <div class="tip-text"> {{tip.tip}}
            @if (tip.helpId) {
              <help-link [helpId]="tip.helpId">{{ LL.common.buttons.learnMore() }}</help-link>
            }
          </div>
          @for (hint of tip.hints; track hint) {
            <ul>
              <li>
                ({{hint.item}})
                <ul>
                  @for (day of hint.days; track day) {
                    <li>
                      {{day}}
                    </li>
                  }
                </ul>
              </li>
            </ul>
          }
        </div>
      </li>
    }
  </ol>

</cs-content>